<template>
  <div class="individual-preloader" v-if="loading">
    <div class="preloader-overlay">
      <div class="bar">
        <div class="circle"></div>
        <p>Абель</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "IndividualPreloader",
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.individual-preloader {
  position: relative;
  min-height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.preloader-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
  background: transparent;
  width: 100%;
  overflow-x: hidden;
  overflow-y: hidden;

  border-radius: 12px;
}

.bar {
  position: relative;
  height: 2px;
  width: 300px;
  margin: 0 auto;
  background: #3b2cdd;
  margin-top: 150px;
}

.circle {
  position: absolute;
  top: -33px;
  margin-left: -30px;
  height: 60px;
  width: 60px;
  left: 0;
  background: #3b2cdd;
  border-radius: 30%;
  -webkit-animation: move 4s infinite;
}

p {
  position: absolute;
  top: -20px;
  right: -85px;
  text-transform: uppercase;
  color: #f8f9fa !important;
  font-family: 'Roboto', helvetica, sans-serif !important;
  font-weight: bold !important;
  font-size: 16px !important;
}

@-webkit-keyframes move {
  0% {left: 0;}
  50% {left: 100%; -webkit-transform: rotate(450deg); width: 150px; height: 150px;}
  75% {left: 100%; -webkit-transform: rotate(450deg); width: 150px; height: 150px;}
  100% {right: 100%;}
}
</style>
